import Vue from 'vue';
import VueRouter from 'vue-router';
import jscookie from 'js-cookie';

Vue.use(VueRouter);

import Center from '@/views/Center'
import Download from '@/views/Center/Resourse/DownloadView';
import Collect from '@/views/Center/Resourse/CollectView.vue';

import Video from '@/views/Center/Course/VideoView.vue';
import Live from '@/views/Center/Course/LiveView.vue';
import Special from '@/views/Center/Course/SpecialView.vue';
import Geek from '@/views/Center/Course/GeekView.vue';

// import Marrow from '@/views/Center/Subscribe/MarrowView.vue';
import PicText from '@/views/Center/Subscribe/PicTextView.vue';

// import EBook from '@/views/Center/Ebook/EbookView.vue';

const routes = [
  {
    path: '/',
    redirect: '/center',
  },
  {
    path: '/center',
    redirect: '/center/video',
    component: Center,
    meta: {
      title: '学习中心',
      login: true,
    },
    children: [
      {
        path: 'download',
        name: 'download',
        component: Download,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      {
        path: 'collect',
        name: 'collect',
        component: Collect,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      {
        path: 'video',
        name: 'video',
        component: Video,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      {
        path: 'special',
        name: 'special',
        component: Special,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      {
        path: 'geek',
        name: 'geek',
        component: Geek,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      // {
      //   path: 'gitchat',
      //   name: 'marrow',
      //   component: Marrow,
      //   meta: {
      //     title: '学习中心',
      //     login: true,
      //   },
      // },
      {
        path: 'blog',
        name: 'pictext',
        component: PicText,
        meta: {
          title: '学习中心',
          login: true,
        },
      },
      // {
      //   path: 'ebook',
      //   name: 'ebook',
      //   component: EBook,
      //   meta: {
      //     title: '学习中心',
      //     login: true,
      //   },
      // },
    ],
  },
  {
    path: '/announce',
    redirect: '/announce/problem/updownfaq',
    component: () => import('@/views/Announce'),
    meta: {
      title: '学习中心',
      login: false,
    },
    children: [
      {
        path: 'problem/updownfaq',
        name: 'updownfaq',
        component: () => import('@/views/Announce/Problem/UpDownFaq.vue'),
        meta: {
          title: '上传与下载',
          login: false,
        },
      },
      {
        path: 'problem/author',
        name: 'author',
        component: () => import('@/views/Announce/Problem/AuthorLevel.vue'),
        meta: {
          title: '作者等级与权益说明',
          login: false,
        },
      },
      {
        path: 'problem/integral',
        name: 'integral',
        component: () => import('@/views/Announce/Problem/Integral.vue'),
        meta: {
          title: '积分说明',
          login: false,
        },
      },
      {
        path: 'norm/sourceName',
        name: 'sourceName',
        component: () => import('@/views/Announce/Norm/SourceName.vue'),
        meta: {
          title: '资源上传规范公告',
          login: false,
        },
      },

    ],
  },
  {
    path: '/manage',
    redirect: '/manage/download/DownloadDetailed',
    component: () => import('@/views/Manage'),
    meta: {
      title: '学习中心',
      login: false,
    },
    children: [
      {
        path: 'download/DownloadDetailed',
        name: 'DownloadDetailed',
        component: () => import('@/views/Manage/DownloadDetailed'),
        meta: {
          title: '我的下载',
          login: false,
        },
      },
      {
        path: 'download/UpDetailed',
        name: 'UpDetailed',
        component: () => import('@/views/Manage/UpDetailed'),
        meta: {
          title: '我的上传',
          login: false,
        },
      },
    ],
  },
  {
    path: '/nuggets',
    name: 'nuggets',
    meta: { title: '开荒掘金', login: false },
    component: () => import('@/views/Nuggets/index.vue'),
  },
  {
    path: '/nuggets/rule',
    name: 'nuggetsRule',
    meta: { title: '开荒掘金', login: false },
    component: () => import('@/views/Nuggets/rule.vue')
  }
];

const router = new VueRouter({
  routes,
  mode: 'history',
});


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 作者权益页 重定向
  if (to.name === 'author') {
    window.location.href = 'https://blog.csdn.net/VIP_Assistant/article/details/130505333'
    return
  }
  // 资源上传规范公告 重定向
  if (to.name === 'sourceName') {
    window.location.href = 'https://blog.csdn.net/VIP_Assistant/article/details/131659397'
    return
  }
  if (jscookie.get('UserName') || !to.meta.login) {
    next();
  } else {
    const url = encodeURIComponent(window.location.href);
    const loginUrl =
      process.env.VUE_APP_LOGIN_API + '/account/login?from=' + url;
    window.location.href = loginUrl;
  }
});

export default router;
